declare var $: any;

export default class NewsletterSubscription {

	private form: HTMLFormElement;
	private isSubmitting: boolean = false;

	constructor(form: HTMLFormElement) {
		this.form = form;
		if (!this.form) {
			return;
		}
		this.attachEvents();
	}

	private attachEvents() {
		this.form.addEventListener("submit", (event) => {
			this.processNewsletterSubscription(event);
		});
	}

	private processNewsletterSubscription(event) {
		event.preventDefault();
		if (!$(this.form).valid() || this.isSubmitting === true) {
			return;
		}
		this.isSubmitting = true;

		const newsletterBlock = this.form.parentElement as HTMLElement;

		const firstNameInput = this.form.querySelector('.js-newsletter-form-first-name') as HTMLInputElement;
		const emailInput = this.form.querySelector('.js-newsletter-form-email') as HTMLInputElement;
		const jsonNewsletterForm = {
			"firstname": firstNameInput.value,
			"email": emailInput.value,
			"newsletteroptin": true
		}
		fetch("/api/newsletter/subscribe", {
			headers: {
				'Content-Type': 'application/json'
			},
			method: "POST",
			body: JSON.stringify(jsonNewsletterForm)
		})
			.then(response => response.json())
			.then((data) => {
				if (data.SuccessMessages.length == 0 && data.ErrorMessages.length > 0) {
					const newsletterValidationMessage = newsletterBlock.querySelector(".js-newsletter-error");
					newsletterValidationMessage.textContent = data.ErrorMessages[0];
					return;
				}

				newsletterBlock.querySelector(".js-newsletter-title").remove();
				newsletterBlock.querySelector(".js-newsletter-description").remove();
				this.form.remove();

				const successTitleElement = newsletterBlock.querySelector(".js-newsletter-success-title");
				const successDescriptionElement = newsletterBlock.querySelector(".js-newsletter-success-description");

				successTitleElement.classList.remove("u-visuallyhidden");
				successTitleElement.setAttribute("aria-hidden", "false");
				successTitleElement.setAttribute("role", "alert");
				successDescriptionElement.classList.remove("u-visuallyhidden");
				successDescriptionElement.setAttribute("aria-hidden", "false");
				successDescriptionElement.setAttribute("role", "alert");
			})
			.catch((error) => {
				this.isSubmitting = false;
			});
	}
}
